import React, { useState, useEffect, useRef, useCallback } from 'react';
import { GameConfigs } from '../lib/globals/GameConfigs';
import { EVENTS } from '../lib/constants';
import HELPERS from '../lib/globals/helpers/Helpers';
import { isDesktop } from 'react-device-detect';
import { InfoContainer } from './InfoStyled';
import Header from './components/Header';
import Main from './components/Main';

export default function InfoPage({ configs, curr, currAbr }) {
	const [coefs, setCoefs] = useState(configs);
	const [currency, setCurrency] = useState(curr);
	const [currentBet, setcurrentBet] = useState(GameConfigs.currentBet);

	const containerRef = useRef(null);
	// const [clickable, setClickable] = useState(undefined)

	const handleBetChange = useCallback((e) => {
		if (e.detail.betAmount) {
			setcurrentBet(e.detail.betAmount);
			// setClickable(false)
		}
	}, []);

	const handleReelFinished = (e) => {
		if (GameConfigs.win > 0) {
			HELPERS.dispatchCustomEvent(EVENTS.MODAL, { modal: '' });
		}
	};

	useEffect(() => {
		setCoefs(configs);
	}, [configs]);

	useEffect(() => {
		setCurrency(curr);
	}, [curr]);

	useEffect(() => {
		// Add the resize event listener
		window.addEventListener(EVENTS.BET_UPDATE, handleBetChange);
		window.addEventListener(EVENTS.REEL_FINISHED, handleReelFinished);
		// Return the cleanup function
		return () => {
			// Remove the resize event listener
			window.removeEventListener(EVENTS.BET_UPDATE, handleBetChange);
			window.removeEventListener(EVENTS.REEL_FINISHED, handleReelFinished);
		};
	}, [handleBetChange]);

	useEffect(() => {
		window.addEventListener('click', handleClickOutside);
		const infoElement = containerRef.current;
		if (infoElement) {
			infoElement.addEventListener('wheel', handleWheel, { passive: false });
			infoElement.addEventListener('touchmove', handleTouchMove, {
				passive: false
			});
		}
		return () => {
			window.removeEventListener('click', handleClickOutside);
			if (infoElement) {
				infoElement.removeEventListener('wheel', handleWheel);
				infoElement.removeEventListener('touchmove', handleTouchMove);
			}
		};
	}, []);

	const handleWheel = (event) => {
		if (event.ctrlKey) {
			event.preventDefault();
		}
	};
	const handleTouchMove = (event) => {
		if (event.touches.length > 1) {
			event.preventDefault();
		}
	};
	const handleClickOutside = (event) => {
		if (isDesktop) {
			if (window.restrictModalClose) {
				window.restrictModalClose = false;
				return;
			}

			if (
				containerRef.current &&
				!containerRef.current.contains(event.target) &&
				GameConfigs.modal === 'info'
			) {
				HELPERS.dispatchCustomEvent(EVENTS.MODAL, { modal: '' });
			}
		}
	};

	const close = () => {
		HELPERS.dispatchCustomEvent(EVENTS.MODAL, { modal: '' });
		GameConfigs.modal = '';
	};
	return (
		<InfoContainer ref={containerRef}>
			<Header close={close} />
			<Main
				currency={currency}
				currentBet={currentBet}
				coefs={coefs}
				currAbr={currAbr}
			/>
		</InfoContainer>
	);
}
